export default __webpack_public_path__ + "static/media/Housekarl's Pledge.e28efabf.jpg";